import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/cuentas-cobro',
    name: 'cuentas-cobro.index',
    component: () => import('./views/CuentasCobroIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'cuentas_cobro.read',
      breadcrumb: 'Cuentas de cobro',
    },
  },
  {
    path: '/cuentas-cobro/nueva',
    name: 'cuentas-cobro.nueva',
    component: () => import('./views/CuentaCobroEditor.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'cuentas_cobro.create',
      breadcrumb: 'Nueva cuenta de cobro',
    },
  },
  {
    path: '/cuentas-cobro/:id',
    name: 'cuentas-cobro.detalle',
    component: () => import('./views/CuentaCobroEditor.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'cuentas_cobro.read',
      breadcrumb: 'Cuenta de cobro',
    },
  },
]

export default routes
